<template>
    <div>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form @submit.prevent="cambiarPass">
                <v-slide-y-transition>
                    <v-row v-if="invalid">
                        <v-col cols="12" md="12">
                            <v-alert class="rounded-0 font-weight-regular text-body-2" border="left"
                                icon="mdi-alert-circle" colored-border color="orange darken-2">
                                La contraseña debe tener 8 caracteres o más y al menos una letra mayúscula.
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-slide-y-transition>
                <v-row class="my-0 py-0">
                    <v-col cols="12" md="12">
                        <ValidationProvider vid="confirmation" rules="required|password_strong|confirmed:confirmation"
                            v-slot="v">
                            <v-text-field v-model="confirmation" :error-messages="v.errors[0]" outlined
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                                name="password" label="Contraseña" @click:append="show1 = !show1"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12" class="my-0 py-0">
                        <ValidationProvider rules="required|confirmed:confirmation" v-slot="v">
                            <v-text-field v-model="password" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show2 ? 'text' : 'password'" :error-messages="v.errors[0]" outlined
                                label="Confirmar contraseña" class="input-group--focused"
                                @click:append="show2 = !show2"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12" class="d-flex align-start justify-start my-0 py-0">
                        <ValidationProvider name="terminos" rules="required" v-slot="v">
                            <v-checkbox v-model="check" color="primary" value="true" :error-messages="v.errors"
                                class="ma-0 pa-0" hide-details="auto">
                                <template v-slot:label>
                                    <span
                                        :class="(check) ? `font-weight-medium primary--text` : `dark--text font-weight`">
                                        Al actualizar mi contraseña, acepto que se cerrará mi sesión y deberé iniciar
                                        sesión nuevamente.
                                    </span>
                                </template>
                            </v-checkbox>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12" class="d-flex justify-end">
                        <v-btn :disabled="invalid || !check" class="pa-5" width="136" elevation="0" color="primary"
                            type="cambiarPass">
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            show1: false,
            show2: false,
            password: '',
            confirmation: '',
            check: false,
        }
    },
    methods: {
        ...mapActions('dataUser', ['cambiarPassword']),
        ...mapActions('notificaciones', ['showSnack', 'startLoading']),
        ...mapActions('auth', ['cerrarSesion']),

        cambiarPass() {
            this.$emit('cambioPass')
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.cambiarPassword({
                        nroafi: this.nroafi, pwd: this.password
                    }).then(() => {
                        setTimeout(() => {
                            this.startLoading()
                            this.cerrarSesion()
                        }, 2000);
                    })
                } else {
                    this.showSnack({
                        message: 'Error al intentar cambiar su contraseña.',
                        type: '400'
                    })
                }
            })
        }
    },
    computed: {
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('auth', ['nroafi'])
    }
}
</script>